import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'account-closed',
  templateUrl: './account-closed.component.html',
})
export class AccountClosedComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
